import { Button, Form, Input, Modal, Select } from "antd";
import { useEffect } from "react";

import { selectFormOptionsNoFormatting } from "../../../../../utils/helper";

const CreateEditCodeModal = ({
  isModalOpen = false,
  isEdit = false,
  setIsModalOpen = () => {},
  initialValues = {},
  handleCreateEdit = () => {}
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (isEdit && initialValues) {
      form.setFieldsValue(initialValues);
    } else {
      form.resetFields();
    }
  }, [isEdit, initialValues, form, isModalOpen]);

  const onFinish = (values) => {
    const payload = isEdit ? { ...initialValues, ...values } : values;
    handleCreateEdit(payload);
    setIsModalOpen(false);
    form.resetFields();
  };

  return (
    <Modal
      title={isEdit ? "Edit Code" : "Create Code"}
      centered
      open={isModalOpen}
      footer={null}
      onCancel={() => {
        setIsModalOpen(false);
        form.resetFields();
      }}
    >
      <Form form={form} name="create_edit_code_form" layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="language"
          label="Language"
          rules={[
            {
              required: true,
              message: "Please select a language!"
            }
          ]}
        >
          <Select
            options={selectFormOptionsNoFormatting(["C++", "Java", "Python"])}
            showSearch
            allowClear
          />
        </Form.Item>
        <Form.Item
          name="code"
          label="Code"
          rules={[
            {
              required: true,
              message: "Please enter a code snippet!"
            }
          ]}
        >
          <Input.TextArea rows={6} />
        </Form.Item>
        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit" block>
            {isEdit ? "Update" : "Create"} Code
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateEditCodeModal;
